export default __webpack_public_path__ + "static/media/recycle-bin.37b0b4f1.svg";